import { useEffect, useRef, useState } from "react"
import { InputForm, TextAreaForm } from "../atoms/input"
import { StandardButton } from "../atoms/buttons"
import { VerticalLayout } from "../components/layout"

export const OpenQuiz = ({ data, textInput, updateAnswer }) => {
    const [question, setQuestion] = useState("")
    useEffect(() => {
        setQuestion(data?.quiz_question)
    }, [])
    const handleChangeText = (text) => {
        const copyData = { ...data }
        copyData.quiz_question = text
        copyData.quiz_answer_content = []
        setQuestion(text)
        updateAnswer(copyData)
    }

    return (
        <div className="horizontal match-mol" >
            <VerticalLayout>

                <InputForm
                    typeInput={(text) => handleChangeText(text)}
                    value={question}
                    placeholder={`Stel hier je openvraag`}
                />

            </VerticalLayout>

        </div>
    )
}